/* eslint-disable react/no-this-in-sfc */
import React from 'react';
import Highcharts, { SeriesOptionsType } from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import { LineChartModel } from '../../core/models/chart';

export interface ILineChart {
  title?: string;
  yAxisTitle: string;
  colors: string[];
  data: LineChartModel[];
  height?: string | null;
  showLegend?: boolean;
  itemDistance?: number;
  decimals?: number;
  legend?: { [key: string]: string | number | boolean };
}

const LineChart = React.memo(function LineChart({
  title,
  yAxisTitle,
  data,
  showLegend = true,
  itemDistance = 10,
  decimals = 2,
  legend = {},
}: ILineChart): JSX.Element {
  const chartData = data.map(
    (item) =>
      ({
        ...item,
        type: 'spline',
        name: item.marketName,
        data: item.chart.map((chart) => [chart.date, chart.value]),
        lineWidth: 1.2,
        marker: {
          radius: 0,
          lineWidth: 1,
        },
      } as SeriesOptionsType)
  );

  const options: Highcharts.Options = {
    chart: {
      type: 'spline',
      zoomType: 'x',
      height: 350,
      backgroundColor: 'transparent',
      spacingRight: 10,
      animation: false,
    },

    credits: {
      enabled: false,
    },
    colors: [
      '#E20030',
      '#007FDC',
      '#FF8819',
      '#2b908f',
      '#8085e9',
      '#f15c80',
      '#e4d354',
      '#434348',
      '#90ed7d',
      '#91e8e1',
    ],
    title: {
      text: undefined,
    },

    tooltip: {
      // eslint-disable-next-line object-shorthand
      // formatter: function formatter() {
      //   const date = format(this.x, 'EEEE, d LLL yy');
      //   return `<span style="font-size: 11px">${date}</span> <br>
      //           <span style="color:${this.color}">●</span>
      //           ${this.series.name}: <strong>${this.y.toFixed(2)} </strong>`;
      // },
      valueDecimals: decimals,
      xDateFormat: '%A, %b %e %Y',
    },

    xAxis: {
      type: 'datetime',
      dateTimeLabelFormats: {
        day: '%d. %b',
      },
      labels: {
        style: {
          textOverflow: 'visible',
          whiteSpace: 'nowrap',
        },
      },
    },

    yAxis: {
      lineWidth: 0,
      labels: {
        formatter: function formatter() {
          return String(Number(this.value.toFixed(decimals)));
        },
      },
      title: {
        text: yAxisTitle,
      },
    },

    legend: {
      enabled: showLegend,
      align: 'center',
      itemDistance,
      itemMarginBottom: 12,
      symbolPadding: 8,
      ...legend,
    },

    plotOptions: {
      series: {
        label: {
          connectorAllowed: false,
        },
        animation: false,
      },
    },

    time: {
      useUTC: true,
    },

    series: [...chartData],
  };

  return (
    <div className="w-100">
      {title ? <h3 className="pl-2-8">{title}</h3> : null}
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
});

export default LineChart;
